import { c } from "./colors";
import { Frame, type IllustrationProps } from "./Frame";

export function BlockedIllustration(props: IllustrationProps) {
  return (
    <Frame {...props} tone="danger">
      <path d="M60 78V62a20 20 0 0 1 40 0v16" stroke={c.d300} strokeWidth="10" />
      <rect x="46" y="74" width="68" height="54" rx="12" fill={c.d500} />
      <circle cx="80" cy="96" r="8" fill={c.n0} />
      <rect x="77" y="100" width="6" height="14" rx="3" fill={c.n0} />
    </Frame>
  );
}
